import type { GetProposalQuery } from "~/graphql/client"

export const DEFAULT_USER: GetProposalQuery[`proposal`][`seller`] = {
  createdAt: ``,
  updatedAt: ``,
  id: ``,
  firstName: ``,
  lastName: ``,
  email: ``,
  phone: ``,
  permissions: [],
  bio: ``,
  profileImage: null,
  powurUserId: null,
  enterpriseId: null,
  licenses: [],
  externalIds: [],
}
